<template>
  <div class="page" style="background-color: #ffffff;width: 100%;height: 100%;">
    <van-nav-bar
      title="新增门店信息"
      left-text="返回"
      left-arrow
      @click-left="historyBack"
    />
    <el-form ref="form" :model="addinteboStore" label-width="100px" size="mini" :rules="rules" style="padding: 20px">
      <el-row>
        <el-col :span="24">
          <el-form-item label="品牌" prop="parentid">
            <el-select v-model="addinteboStore.parentid" style="width: 150px" filterable>
              <el-option :label="item.parentname" :value="item.parentid" :key="key" v-for="(item,key) in intebostoreparents"></el-option>
            </el-select>
            <el-button @click.prevent="openparent()">新增品牌</el-button>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="门店名称" prop="storename">
            <el-input v-model="addinteboStore.storename"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="是否合作" prop="coop">
            <el-radio-group v-model="addinteboStore.coop">
              <el-radio-button label="0">否</el-radio-button>
              <el-radio-button label="1">是</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
        <el-row>
            <el-col :span="24">
                <el-form-item label="赠送店销" prop="phone">
                    {{addinteboStore.salecount}}
                </el-form-item>
            </el-col>
        </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="手机号码" prop="phone">
            <el-input v-model="addinteboStore.phone" type="number"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="负责人" prop="head">
            <el-input v-model="addinteboStore.head"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
        <el-form-item label="所在城市" prop="city">
            <el-cascader :options="provinceData" v-model="shenshi" size="mini"
                         style="width: 100%"></el-cascader>
        </el-form-item>
        <el-form-item label="详细地址" prop="address">
            <el-input v-model="addinteboStore.address"></el-input>
        </el-form-item>
        <el-form-item label="门店类型" prop="storetype">
            <el-radio-group v-model="addinteboStore.storetype">
                <el-radio :label="1">街道店</el-radio>
                <el-radio :label="2">社区店</el-radio>
                <el-radio :label="3">小区店</el-radio>
                <el-radio :label="4">商场店</el-radio>
                <el-radio :label="5">综合店</el-radio>
            </el-radio-group>
        </el-form-item>
        <el-form-item label="开业时间" prop="opendate">
            <el-date-picker value-format="yyyy-MM-dd" size="mini" style="width: 100%"
                            v-model="addinteboStore.opendate"
                            type="date"
                            placeholder="选择日期">
            </el-date-picker>
        </el-form-item>
        <el-form-item label="营业面积" prop="area">
            <el-input-number style="text-align: left;width: 100%" :precision="0" :controls="false" :min="0" size="mini" v-model="addinteboStore.area"></el-input-number>
        </el-form-item>
        <el-form-item label="房间数" prop="room">
            <el-input-number style="text-align: left;width: 100%" :precision="0" :controls="false" :min="0" size="mini" v-model="addinteboStore.room"></el-input-number>
        </el-form-item>
        <el-form-item label="床位数" prop="bed">
            <el-input-number style="text-align: left;width: 100%" :precision="0" :controls="false" :min="0" size="mini" v-model="addinteboStore.bed"></el-input-number>
        </el-form-item>
        <el-form-item label="1年内变迁" prop="change">
            <el-switch v-model="addinteboStore.change" active-text="是" inactive-text="否" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
        <el-form-item label="6个月平均业绩" prop="avgperf">
            <el-input-number style="text-align: left;width: 100%" :precision="0" :controls="false" :min="0" size="mini" v-model="addinteboStore.avgperf"></el-input-number>
        </el-form-item>
        <el-form-item label="店长/经理人数" prop="managers">
            <el-input-number style="text-align: left;width: 100%" :precision="0" :controls="false" :min="0" size="mini" v-model="addinteboStore.managers"></el-input-number>
        </el-form-item>
            <el-table height="120px" class="productTable" border :data="storeManagerData" size="mini" style="text-align: center" highlight-current-row :bean="inteboStoreManager">
                <el-table-column label="姓名"  align="center"prop="name">
                    <template slot-scope="scope">
                        <el-input :ref="scope.column.property+'_'+scope.$index" @keyup.enter.native="tableEnter(scope)" size="mini" v-model="scope.row.name"></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="工龄"  align="center"prop="gl">
                    <template slot-scope="scope">
                        <el-input-number style="text-align: left;width: 100%" :ref="scope.column.property+'_'+scope.$index" :precision="0"
                                         :controls="false" @keyup.enter.native="tableEnter(scope)" size="mini" v-model="scope.row.gl"></el-input-number>
                    </template>
                </el-table-column>
            </el-table>
        <el-form-item label="顾问导师人数" prop="gwnumber">
            <el-input-number style="text-align: left;width: 100%" :precision="0" :controls="false" :min="0" size="mini" v-model="addinteboStore.gwnumber"></el-input-number>
        </el-form-item>
        <el-table height="150px" class="productTable" border :data="storeGWData" size="mini" style="text-align: center" highlight-current-row :bean="inteboStoreManager">
            <el-table-column label="姓名"  align="center"prop="name">
                <template slot-scope="scope">
                    <el-input :ref="scope.column.property+'_'+scope.$index" @keyup.enter.native="tableEnter(scope)" size="mini" v-model="scope.row.name"></el-input>
                </template>
            </el-table-column>
            <el-table-column label="工龄"  align="center"prop="gl">
                <template slot-scope="scope">
                    <el-input-number style="text-align: left;width: 100%" :ref="scope.column.property+'_'+scope.$index" :precision="0"
                                     :controls="false" @keyup.enter.native="tableEnter(scope)" size="mini" v-model="scope.row.gl"></el-input-number>
                </template>
            </el-table-column>
        </el-table>
        <el-form-item label="美容师总数" prop="beautynumber">
            <el-input-number style="text-align: left;width: 100%" :precision="0" :controls="false" :min="0" size="mini" v-model="addinteboStore.beautynumber"></el-input-number>
        </el-form-item>
        <el-form-item label="日均客流" prop="kl">
            <el-input-number style="text-align: left;width: 100%" :precision="0" :controls="false" :min="0" size="mini" v-model="addinteboStore.kl"></el-input-number>
        </el-form-item>
        <el-form-item label="每月到店1次人数" prop="beauty1number">
            <el-input-number style="text-align: left;width: 100%" :precision="0" :controls="false" :min="0" size="mini" v-model="addinteboStore.beauty1number"></el-input-number>
        </el-form-item>
        <el-form-item label="消费2W的顾客" prop="beauty2number">
            <el-input-number style="text-align: left;width: 100%" :precision="0" :controls="false" :min="0" size="mini" v-model="addinteboStore.beauty2number"></el-input-number>
        </el-form-item>
      <el-row>
        <el-col :span="24">
          <el-button type="primary" @click="saveInteboStore" style="width: 100%">保存</el-button>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
export default {
  data() {
      return {
          shenshi:[],
          columnIndexs:[],
          inteboStoreManager:{
              storeid:"",
              name:"",
              gl:0,
              createdate:"",
              createtor:"",
              createtorname:"",
          },
          storeGWData:[],
          storeManagerData:[],
          provinceData:[],
          addinteboStore: {
              storeid: "",
              storename: "",
              parentid: "",
              phone: "",
              head: "",
              coop: 1,
              city: "",
              address:"",
              opendate:"",
              storetype:"",
              area:0,
              room:0,
              bed:0,
              change:1,
              avgperf:0,
              dealstatus:0,
              managers:0,
              gwnumber:0,
              beautynumber:0,
              beauty1number:0,
              beauty2number:0,
              kl:0,
              gk1:0,
              xfamount:0,
          },
          intebostoreparents: [],
          rules: {
              storename: [
                  {required: true, message: "请输入门店名称", trigger: 'blur'},
              ],
              parentid: [
                  {required: true, message: "请选择品牌", trigger: 'blur'},
              ],
          },
          opertype: "add",
      }
  },
  created() {
      if (this.$route.query.parentid) {
          this.addinteboStore.parentid = this.$route.query.parentid;
      }
      this.getInteboParentStore();
      this.opertype = this.$route.query.type;
      let updateStore = this.$route.query.updateInteboStore;
      if (updateStore) {
          this.addinteboStore = updateStore;
      }
      this.shenshi=[];
      this.storeManagerData=[];
      this.storeGWData=[];
      this.getProvince();
      if(this.opertype=="add"){
          this.storeManagerData.push(this.$copy(this.inteboStoreManager));
          this.storeGWData.push(this.$copy(this.inteboStoreManager));
      }
      else{
          this.getInteboStoreManagerByStoreId();
          if(this.addinteboStore.city){
              let citys=this.addinteboStore.city.split(",");
              for(let val of citys){
                  this.shenshi.push(parseInt(val))
              }
          }
      }
  },
  methods: {
      getInteboStoreManagerByStoreId(){
          this.$post("inteboStore/getInteboStoreManagerByStoreId",{storeid:this.addinteboStore.storeid}).then(res => {
              if(res.sucess){
                  let obj=res.object;
                  if(obj!=null && obj.length>0){
                      for(let val of obj){
                          if(val.type==1){
                              this.storeManagerData.push(val);
                          }
                          else{
                              this.storeGWData.push(val);
                          }
                      }
                  }

                  if(this.storeManagerData.length<1){
                      this.storeManagerData.push(this.$copy(this.inteboStoreManager));
                  }
                  if(this.storeGWData.length<1){
                      this.storeGWData.push(this.$copy(this.inteboStoreManager));
                  }
              }
              else{
                  this.$message({message: res.message, type: 'error'});
              }
          });
      },
      getProvince(){
          this.$post("basis/getProvinceCityDistrict").then(res => {
              if (res.sucess) {
                  let temp = {};
                  let tempCity = {};
                  for (let Province of res.object.Province) {
                      temp = {label: Province.provinceName, value: Province.provinceID, children: []};
                      for (let City of res.object.City) {
                          if (Province.provinceID == City.provinceID) {
                              tempCity = {label: City.cityName, value: City.cityID};
                              /*for (let District of response.object.District) {
                                  if (City.cityID == District.cityID) {
                                      tempCity.children.push({
                                          label: District.districtName,
                                          value: District.districtID
                                      });
                                  }
                              }*/
                              temp.children.push(tempCity);
                          }
                      }
                      this.provinceData.push(temp);
                  }

              }
              else{
                  this.$message({
                      message: res.message,
                      type: 'error',
                  });
              }
          });
      },
      openparent() {
          this.$router.push('/addinteboparentstore');
      },
      saveInteboStore() {
          this.$refs["form"].validate((valid) => {
              if (valid) {
                  let url = "inteboStore/saveInteboStore";
                  if (this.opertype == "update") {
                      url = "inteboStore/updateInteboStore";
                  }

                  if(this.shenshi.length>0){
                      this.addinteboStore.city=this.shenshi.join(",");
                  }
                  let inteboStoreManagers=[];
                  for(let val of this.storeManagerData) {
                      if (val.name) {
                          val.type=1;
                          val.createtor=localStorage.getItem("staffid");
                          val.createtorname=localStorage.getItem("staffname");
                          inteboStoreManagers.push(val);
                      }
                  }

                  for(let val of this.storeGWData){
                      if (val.name) {
                          val.type=2;
                          val.createtor=localStorage.getItem("staffid");
                          val.createtorname=localStorage.getItem("staffname");
                          inteboStoreManagers.push(val);
                      }
                  }

                  let inteboStoreVo=new Object();
                  inteboStoreVo.inteboStore=this.addinteboStore;
                  inteboStoreVo.inteboStoreManagers=inteboStoreManagers;
                  this.$postw(url, inteboStoreVo).then(res => {
                      if (res.sucess) {
                          this.$message({
                              message: '保存成功',
                              type: 'success',
                              duration: 1000,
                              onClose: () => {
                                  this.$router.push('/intebostore');
                              }
                          });
                      }
                  });
              }
          });
      },
      getInteboParentStore() {
          this.$post("inteboStore/getInteboParentStore").then(res => {
              if (res.sucess) {
                  this.intebostoreparents = res.object;
              }
          })
      },
      tableEnter(scope) {
          var column = scope.store.states.columns;
          var length = column.length;
          if (this.columnIndexs.length < 1) {
              if (column != null && column.length > 0) {
                  for (var i = 0; i < column.length; i++) {
                      this.columnIndexs[column[i].property] = i;
                  }
              }
          }
          var conname = scope.column.property + "_" + scope.$index;
          var curCon = this.$refs[conname];
          console.log(curCon.$options._componentTag);
          if(curCon.$options._componentTag=="el-select"){
              curCon.blur();
          }
          if( curCon.$options._componentTag=="el-date-picker") {
              curCon.hidePicker();
          }
          console.log(curCon);
          var index = this.columnIndexs[scope.column.property];
          while (index <= length - 1) {
              if (index == column.length - 1) {
                  if ((scope.store.table.$options.propsData.data.length - 1) == scope.$index) {
                      scope.store.table.$options.propsData.data.push(this.$copy(scope.store.table.$attrs.bean));
                      //this.rooms.push(this.$copy(this.room));
                      this.$nextTick(function () {
                          conname = column[0].property+"_" + (scope.$index + 1);
                          var con = this.$refs[conname];
                          con.focus();
                          con.$children[0].select();
                      });
                  }
                  else {
                      conname = column[0].property+"_" + (scope.$index + 1);
                      var con = this.$refs[conname];
                      con.focus();
                      con.select();
                  }
              }
              else {
                  var property = scope.store.states.columns[index + 1].property;
                  conname = property + "_" + scope.$index;
                  var con = this.$refs[conname];
                  if (con != undefined) {
                      if (con.disabled == false) {
                          con.focus();
                          con.$children[0].select();
                          break;
                      }
                  }
              }
              index++
          }
      }
  }
}
</script>
<style lang="scss" rel="stylesheet/scss">
.page .el-input-number .el-input__inner {
    text-align: left;
}

.productTable {
    .el-button{
        padding: 0px;
    }
    &.el-table--enable-row-hover {
        /*.el-table__body {
            tr{
                &:hover{
                    &>td{
                        background-color:transparent;
                    }
                }
            }
        }*/
    }
    .el-table__row {
        td {
            padding: 0;
            .cell {
                padding: 0 !important;
                .el-input {
                    input {
                        font-size: .7rem;
                        text-align: initial;
                        background-color: transparent;
                        border: 1px solid transparent;
                        height: 1rem;
                        padding: 1rem .5rem;
                        border-radius: 0;
                        &:focus {
                            border-color: #409eff;
                            background-color: #fff;
                        }
                        &[disabled] {
                            background-color: #fbfbfb;
                        }
                    }
                }
                .el-select {
                    .el-input {
                        &.is-disabled {
                            .el-input__inner {
                                &:hover {
                                    border-color: transparent;
                                }
                            }
                        }
                    }
                }
                .el-date-editor {
                    &.el-input {
                        width: auto;
                    }
                    .el-input__prefix {
                        right: 0;
                        left: inherit;
                        .el-input__icon {
                            line-height: 1;
                            opacity: .2;
                        }
                    }
                    .el-input__suffix {
                        .el-icon-circle-close {
                            display: none;
                        }
                    }
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/page/intebo/intebostore/addintebostore.vue